import React, { JSX } from 'react';
import { CardSubtitle, CardText, Col, Row } from 'reactstrap';
import fallback from '../../../_Translations/generated/agency-preferences.en.t.json';
import Keys from '../../../_Translations/generated/agency-preferences.en.t.json.keys';
import useTranslation from '../../Hooks/useTranslation';
import Info from '../UI/Messages/Info';

export interface Props {
  language: string;
  currency: string;
}

const AgencyPreferences = (props: Props): JSX.Element => {
  const { t } = useTranslation('agency-preferences', fallback, Keys);
  const { language, currency } = props;

  return (
    <>
      <Row>
        <Col>
          <Info message={t(Keys.info)} />
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <CardSubtitle tag="h6" className="font-weight-light">
            {t(Keys.language)}
          </CardSubtitle>
          <CardText>{language}</CardText>
        </Col>
        <Col md={6}>
          <CardSubtitle tag="h6" className="font-weight-light">
            {t(Keys.currency)}
          </CardSubtitle>
          <CardText>{currency}</CardText>
        </Col>
      </Row>
    </>
  );
};

export default AgencyPreferences;
